import { emailConstants } from "../constants/emailConstants";
import { emailService } from "../../services/API/emailService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const add_smtp = (postData) => {
  return (dispatch) => {
    dispatch(request());
    emailService.add_smtp(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: emailConstants.ADD_EMAIL_REQUEST, data };
  }

  function success(data) {
    return { type: emailConstants.ADD_EMAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: emailConstants.ADD_EMAIL_FAILURE, error };
  }
};

export const testTemplate = (postData) => {
  return (dispatch) => {
    dispatch(request());
    emailService.testTemplate(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: emailConstants.TEST_EMAIL_REQUEST, data };
  }
  function success(data) {
    return { type: emailConstants.TEST_EMAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: emailConstants.TEST_EMAIL_FAILURE, error };
  }
};

export const testTemplateAbandon = (postData) => {
  return (dispatch) => {
    dispatch(request());
    emailService.testTemplateAbandon(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: emailConstants.TEST_MAIL_REQUEST, data };
  }
  function success(data) {
    /// console.log(emailConstants.TEST_MAIL_SUCCESS);
    return { type: emailConstants.TEST_MAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: emailConstants.TEST_MAIL_FAILURE, error };
  }
};

export const get_email_tempelate_list = (postData) => {
  return (dispatch) => {
    dispatch(request());
    emailService.get_email_tempelate_list(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: emailConstants.GET_EMAIL_TEMPELATE_REQUEST, data };
  }
  function success(data) {
    return { type: emailConstants.GET_EMAIL_TEMPELATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: emailConstants.GET_EMAIL_TEMPELATE_FAILURE, error };
  }
};

export const get_smtp_setting_details = () => {
  return (dispatch) => {
    dispatch(request());
    emailService.get_smtp_setting_details().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: emailConstants.GET_EMAIL_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: emailConstants.GET_EMAIL_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: emailConstants.GET_EMAIL_DETAILS_FAILURE, error };
  }
};

export const get_email_tempelate_details = (templateID) => {
  return (dispatch) => {
    dispatch(request());
    emailService.get_email_tempelate_details(templateID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: emailConstants.GET_EMAIL_TEMPELATE_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: emailConstants.GET_EMAIL_TEMPELATE_DETAILS__SUCCESS, data };
  }
  function failure(error) {
    return { type: emailConstants.GET_EMAIL_TEMPELATE_DETAILS_FAILURE, error };
  }
};

export const update_email_tempelate = (postData) => {
  return (dispatch) => {
    dispatch(request());
    emailService.update_email_tempelate(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: emailConstants.UPDATE_EMAIL_TEMPELATE_DETAILS_REQUEST,
      data,
    };
  }
  function success(data) {
    return {
      type: emailConstants.UPDATE_EMAIL_TEMPELATE_DETAILS__SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: emailConstants.UPDATE_EMAIL_TEMPELATE_DETAILS_FAILURE,
      error,
    };
  }
};

export const delete_smtp = () => {
  return (dispatch) => {
    dispatch(request());
    emailService.delete_smtp().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: emailConstants.DELETE_SMTP_REQUEST, data };
  }
  function success(data) {
    return { type: emailConstants.DELETE_SMTP_SUCCESS, data };
  }
  function failure(error) {
    return { type: emailConstants.DELETE_SMTP_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/emailActions.js